/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_bulk_import_contacts_csv_api_campaigns__campaign_id__contacts_import_post } from '../models/Body_bulk_import_contacts_csv_api_campaigns__campaign_id__contacts_import_post';
import type { BulkContactImportRequest } from '../models/BulkContactImportRequest';
import type { BulkContactImportResponse } from '../models/BulkContactImportResponse';
import type { ExportContactsResponse } from '../models/ExportContactsResponse';
import type { ExportFormat } from '../models/ExportFormat';
import type { OnDuplicate } from '../models/OnDuplicate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CampaignContactsService {
    /**
     * Bulk Import Contacts Json
     * @param campaignId
     * @param requestBody
     * @returns BulkContactImportResponse Successful Response
     * @throws ApiError
     */
    public static bulkImportContactsJsonApiCampaignsCampaignIdContactsPost(
        campaignId: string,
        requestBody: BulkContactImportRequest,
    ): CancelablePromise<BulkContactImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/contacts',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Import Contacts Csv
     * @param campaignId
     * @param formData
     * @param onDuplicate
     * @returns BulkContactImportResponse Successful Response
     * @throws ApiError
     */
    public static bulkImportContactsCsvApiCampaignsCampaignIdContactsImportPost(
        campaignId: string,
        formData: Body_bulk_import_contacts_csv_api_campaigns__campaign_id__contacts_import_post,
        onDuplicate: OnDuplicate = 'skip',
    ): CancelablePromise<BulkContactImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/campaigns/{campaign_id}/contacts/import',
            path: {
                'campaign_id': campaignId,
            },
            query: {
                'on_duplicate': onDuplicate,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Contacts
     * @param campaignId
     * @param status Filter by latest contact state
     * @param email Filter by email (partial match)
     * @param dateFrom Filter contacts created from this date
     * @param dateTo Filter contacts created until this date
     * @param format Response format: json or csv
     * @param limit
     * @param offset
     * @returns ExportContactsResponse Export contacts as JSON or CSV
     * @throws ApiError
     */
    public static exportContactsApiCampaignsCampaignIdContactsExportGet(
        campaignId: string,
        status?: (string | null),
        email?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        format: ExportFormat = 'json',
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<ExportContactsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/campaigns/{campaign_id}/contacts/export',
            path: {
                'campaign_id': campaignId,
            },
            query: {
                'status': status,
                'email': email,
                'date_from': dateFrom,
                'date_to': dateTo,
                'format': format,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
